import { useState, useEffect } from 'react';

export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow]     = useState(false);
  const [isIOS, setIsIOS]   = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if already dismissed
    if (localStorage.getItem('pwa-install-dismissed')) return;

    // Detect iOS
    const ios = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
    const standalone = window.navigator.standalone;
    setIsIOS(ios);

    // Show iOS instructions if not already installed
    if (ios && !standalone) {
      setTimeout(() => setShow(true), 3000);
      return;
    }

    // Android / Desktop — capture install prompt
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setTimeout(() => setShow(true), 3000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') {
      setShow(false);
      setPrompt(null);
    }
  };

  const handleDismiss = () => {
    setShow(false);
    setDismissed(true);
    localStorage.setItem('pwa-install-dismissed', '1');
  };

  if (!show || dismissed) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 80, left: 16, right: 16, zIndex: 9999,
      background: '#1A3A5C', borderRadius: 14, padding: '16px 18px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      border: '1px solid rgba(126,184,212,0.2)',
      animation: 'slideUp 0.4s ease',
    }}>
      <style>{`@keyframes slideUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }`}</style>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ fontSize:28 }}>📱</div>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:'#F5F0E8', marginBottom:2 }}>Install HPM Logbook</div>
            <div style={{ fontSize:11, color:'#7EB8D4' }}>Add to your home screen for quick access</div>
          </div>
        </div>
        <button onClick={handleDismiss}
          style={{ background:'none', border:'none', color:'#7EB8D4', fontSize:18, cursor:'pointer', padding:0, lineHeight:1 }}>✕</button>
      </div>

      {isIOS ? (
        <div style={{ fontSize:12, color:'rgba(245,240,232,0.8)', lineHeight:1.7, background:'rgba(255,255,255,0.07)', borderRadius:8, padding:'10px 12px', marginBottom:12 }}>
          Tap <strong style={{ color:'#7EB8D4' }}>Share</strong> <span style={{ fontSize:14 }}>⬆️</span> at the bottom of your browser, then tap <strong style={{ color:'#7EB8D4' }}>"Add to Home Screen"</strong>
        </div>
      ) : (
        <button onClick={handleInstall}
          style={{ width:'100%', padding:'11px', background:'linear-gradient(135deg, #7EB8D4, #4FA8C8)', color:'#1A3A5C', border:'none', borderRadius:8, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans'", marginBottom:8 }}>
          ✦ Install App
        </button>
      )}

      <button onClick={handleDismiss}
        style={{ width:'100%', padding:'8px', background:'transparent', border:'1px solid rgba(126,184,212,0.3)', color:'#7EB8D4', borderRadius:8, fontSize:12, cursor:'pointer', fontFamily:"'DM Sans'" }}>
        Not now
      </button>
    </div>
  );
}
